import { useCallback, useEffect } from 'react'
import { formatRows } from '../../../utils/format';
import { useLocation } from 'react-router-dom';
import RestProjectController from '../../../hooks/RestProjectController'
import { extractRootDomain } from '../../../utils/Utils'

const projectDetailController = (model) => {

  // Hooks
  const { rest } = RestProjectController();

  useEffect(()=> {
    handleSearchProjects(null)
  }, [])

  const handleSearchProjects = useCallback(async (cleanParams: boolean) => {
    const params = { };

    model.setIsLoading((prev) => ({ ...prev, projects: true }))
    rest({ params, endpoint: 'getProjects' })
      .then((data) => {
        model.setProjectsData(data)
        const project = data.find((item)=> extractRootDomain(item.property) === extractRootDomain(location.state.project))
        model.setProjectSelected(project.property)

        // Initial values
        model.setProject(project.property)
        model.setDateRange({ dateFrom: location.state.dateFrom, dateTo: location.state.dateTo })
      })
      .catch((error) => {
        console.error(`Error:`, error);
      })
      .finally(() => {
        model.setIsLoading((prev) => ({ ...prev, projects: false }))
      })

  }, []);

  const location = useLocation();

  useEffect(() => {
    if (model.projectSelected===0){
      return
    }
    model.setProject(model.projectSelected)
  }, [model.projectSelected])

  useEffect(() => {
    if (!model.filter.get('dateFrom') || !model.filter.get('dateTo')){
      return
    }
    model.setDateRange({ dateFrom: model.filter.get('dateFrom'), dateTo: model.filter.get('dateTo') })
  }, [model.filter])


  const handleGlobalMetricToggle = (metric: string) => model.setGlobalMetrics(prev => ({
    ...prev,
    [metric]: !prev[metric]
  }));

  const filteredColumns = (columns: any[]) => columns.filter((column) => column.field === 'keys' || model.globalMetrics[column.field]);
  const formattedRows = (rows: any[], key: string) => formatRows(rows, model.projectInfo?.currentData?.maxMinClicks?.[key] || {});

  // Applu params when any of the filter changes
  const handleFilterUpdate = (name, from, to, action) => {
    model.setFilter((prevItems) => {
      const newItems = new Map([...prevItems]);

      // Initialize an object to store filter values directly
      const payload = {};

      if (action === "delete") {
        // Remove the filter keys from the Map
        newItems.delete(`${name}From`);
        newItems.delete(`${name}To`);
        newItems.delete(`${name}`);
      } else if (name === 'intention') {
        newItems.set(`${name}`, action);
      } else {
        if (from) newItems.set(`${name}From`, from);
        if (to) newItems.set(`${name}To`, to);
      }

      // Convert the Map into an object with only raw values
      newItems.forEach((value, key:any) => {
        payload[key] = value; // Store only the value, no extra object
      });

      // Update model state (if needed)
      model.setFilter(newItems);

      return new Map(newItems); // Ensure React detects changes
    });
  };

  return {
    handleGlobalMetricToggle,
    filteredColumns, formattedRows,
    handleFilterUpdate
  }

}

export default projectDetailController